import scrollArrow from '@/static/assets/pet/scroll-arrow.png';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled, { keyframes } from 'styled-components';

const scrollArrowAnimation = keyframes`
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(20px);
    }
`;

const ScrollArrow = styled.div`
  background-image: url('${scrollArrow.src}');
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
  animation: ${scrollArrowAnimation} 1.5s ease-in-out alternate infinite;

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: 42px;
        height: 42px;
    `}
`;

export default ScrollArrow;
